export function getQuoteLineItemForProduct(quoteState, product) {
  const productId = product?.product_id ?? product?.id;
  if (!productId || !quoteState || typeof quoteState !== 'object') {
    return null;
  }

  const entry = quoteState[productId] ?? quoteState[String(productId)];
  if (!entry || entry.quantity == null) {
    return null;
  }

  return entry;
}

export function getQuoteQuantityForProduct(quoteState, product) {
  const entry = getQuoteLineItemForProduct(quoteState, product);
  return entry ? (Number(entry.quantity) || 0) : 0;
}
